import React, { useState, useContext, useId, useRef } from "react";
import { isEmpty } from "lodash";
import { DataContext } from "../../../../context/DataContext";
import { getToken } from "../../../../api/Account";
import { addClientReferenceAsync } from "../../../../api/Clients";
import { useAviso } from "../../../../components/base";
import { CamposReferencia, DialogoReferencia, validarReferencia } from "./DialogoReferencia";

const AgregarReferencia = ({ clientId, setShowModal, localReload, setLocalReload }) => {
  const [valores, setValores] = useState({
    fullName: "",
    telefono: "",
    direccion: "",
    parentesco: "",
  });
  const [errores, setErrores] = useState({});
  // El overlay de carga no bloquea el teclado: el ref corta un segundo envío al instante.
  const enviando = useRef(false);
  const [guardando, setGuardando] = useState(false);

  const idTitulo = useId();
  const token = getToken();
  const aviso = useAviso();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const cambiar = (campo, valor) => {
    // Devuelve un entero positivo: en el teléfono solo se aceptan dígitos.
    if (campo === "telefono" && !(/^[0-9]+$/.test(valor.toString()) || valor === "")) {
      return;
    }
    setValores((actual) => ({ ...actual, [campo]: valor }));
    if (errores[campo]) setErrores({ ...errores, [campo]: undefined });
  };

  const saveChangesAsync = async () => {
    if (enviando.current) {
      return;
    }
    const faltantes = validarReferencia(valores);
    setErrores(faltantes);
    if (!isEmpty(faltantes)) {
      return;
    }

    enviando.current = true;
    setGuardando(true);
    const data = {
      clientId,
      fullName: valores.fullName,
      telefono: valores.telefono,
      direccion: valores.direccion,
      parentesco: valores.parentesco,
    };
    setIsLoading(true);
    let result;
    try {
      result = await addClientReferenceAsync(token, data);
    } catch (e) {
      enviando.current = false;
      setGuardando(false);
      setIsLoading(false);
      aviso.error("No se pudo conectar con el servidor. Inténtalo de nuevo.");
      return;
    }
    enviando.current = false;
    setGuardando(false);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      aviso.error(result.error || "No se pudo guardar la referencia");
      return;
    }
    setIsLoading(false);
    aviso.exito("Referencia agregada");
    setLocalReload(!localReload);
    setShowModal(false);
  };

  return (
    <DialogoReferencia
      idTitulo={`${idTitulo}-titulo`}
      titulo="Agregar referencia"
      textoGuardar="Agregar referencia"
      guardando={guardando}
      sucio={Object.values(valores).some((v) => v !== "")}
      onGuardar={saveChangesAsync}
      onCerrar={() => setShowModal(false)}
    >
      <CamposReferencia
        prefijo={idTitulo}
        valores={valores}
        errores={errores}
        onCambio={cambiar}
        deshabilitado={guardando}
      />
    </DialogoReferencia>
  );
};

/**
 * Diálogo para agregar una referencia al cliente. Se dibuja solo si `abierto`: al cerrarlo y
 * volver a abrirlo empieza vacío.
 */
const AddReference = (props) => {
  if (props.abierto === false) return null;
  return <AgregarReferencia {...props} />;
};

export default AddReference;
